// ----------------------------------------------------------------------
// <copyright file="Izenda.CommonMessages.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Common messages
 */
!function () {
  var localizer = require('share/localization/Izenda.Localizer');
  module.exports = {
    MESSAGE_TYPE: {
      INFO: 'info',
      ERROR: 'error',
      SUCCESS: 'success',
      WARNING: 'warning',
      INFO_ACCEPT: 'info_accept'
    },
    // Please keep items in order of key (order follow alphabet)
    SUPP_LBL_001: 'No record found.',

    SUPP_MSG_001: 'Are you sure? All your changes will be lost.',
    SUPP_MSG_005: 'Are you sure you want to save all of the modifications?',
    SUPP_MSG_006: 'Details were saved.',
    SUPP_MSG_007: 'Are you sure you want to cancel the changes?',
    SUPP_MSG_008: '{0} is required.',
    SUPP_MSG_019: '{0} must be a number smaller than or equal to {1}.',
    SUPP_MSG_026: 'Another user recently modified this data. Up-to-date data has been reloaded. You can now review and continue your work.',
    SUPP_MSG_028: 'No changes found.',
    M09: 'This foreign data object is invalid when the relationship is dropped here ',
    M10: 'This foreign data object is invalid when the key join is dropped here ',
    FORMAT_NUMBER: 'Please enter a valid value in Numeric format.',
    FORMAT_DATE:   'Please enter a valid value in \'MM/dd/yyyy hh:mm\' format.',
    // Notification Message
    EMPTY_MESSAGE: { type: 'info', message: '' },
    EMAIL_CONFIGURATION: 'The Email Settings for your system/tenant has not been configured yet. Please contact your System Administrator for assistance',
    PROVISION_MAP_DATA: {
      IMPORTING: localizer.getText('NOTIFICATION_PROVISION_MAP_DATA_IMPORTING'),
      IMPORT_FAILED: localizer.getText('NOTIFICATION_PROVISION_MAP_DATA_IMPORT_FAILED')
    },
    NLQCONFIGURATION_STATUS_MESSAGE: {
      COMPLETECONFIGURATION: localizer.getText('NLQ_MODULE_CONFIGURED'),
      CONFIGURATION_FAILED: localizer.getText('NLQ_MODULE_CONFIGURATION_FAILED')
    },

    NLQ_SAVE_REPORT: {
      SAVEING: localizer.getText('NOTIFICATION_NLQ_SAVE_REPORT'),
      SAVE_FAILED: localizer.getText('NOTIFICATION_NLQ_SAVE_REPORT_FAILED')

    },
    RESETNLQ_STATUS_MESSAGE: {
      COMPLETERESET: localizer.getText('NLQ_RESET_SUCCESS'),
      FAILEDRESET: localizer.getText('NLQ_RESET_FAILED')
    },

  };
}();



// WEBPACK FOOTER //
// ./ui/share/messages/Izenda.CommonMessages.js